export default __webpack_public_path__ + "static/media/img--design-3.48e730e1.jpg";